(function () {
  'use strict';
  angular.module('userProfile')
    .factory('UserProfile', ['$resource', function ($resource) {
      return $resource('/me', {}, {
        get: {method: 'GET', isArray: false},
        update: {method: 'POST',url:'/dnMe'},
        save: {method: 'PUT'},
        resend: {url: '/me/resendEmailVerification', method: 'GET'},
        validatePassword: {url: '/me/validatePassword', method: 'GET'}
      });

    }])
    .factory('TaxId', ['$resource', function ($resource) {
      return $resource('/provider/:id', {id: '@id'}, {
        get: {method: 'GET', isArray: false, cache: true}
      });
    }])
    .factory('TaxLocationUtility', ['TaxId', '$q', function (TaxId, $q) {
      var TaxLocationUtility = {};
      TaxLocationUtility.filterLocations = function(locations) {
        //get distinct taxIdLocations
        var taxIds = _.keys(_.countBy(locations, function(loc){return loc.taxId;}));
        var centerIds = _.map(locations, function(loc){ return loc.centerId;});
        var promises = [];
        _.each(taxIds, (taxId) => {
          promises.push(TaxId.get({id: taxId}).$promise.then((data) => {
            return data.locations;
          }));
        });
        return $q.all(promises).then(function(data){
          var taxIdLocations = [].concat.apply([], data);
          return _.filter(taxIdLocations, function(t){
            return t && _.includes(centerIds,t.centerId);
          });
          return [];
        });
      }
      return TaxLocationUtility;
    }]);
})();
